import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { PackageService } from 'src/app/private/services/package.service';

@Component({
  selector: 'app-create-package',
  imports: [SharedModule, MultiSelectModule, ToggleSwitchModule],
  templateUrl: './create-package.component.html',
  styleUrl: './create-package.component.scss'
})
export class CreatePackageComponent {
  packageForm: FormGroup;
  newFeature: string = '';
  isLoading = false;
  @Input() selectedPackage: any = null;
  @Input() type: string = 'Create';
  @Input() formAction: string = 'Create';
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private packageService: PackageService
  ) {
    this.packageForm = this.fb.group({
      package_name: ['', Validators.required],
      type: ['', Validators.required],
      is_customized: [false],
      status: ['Active', Validators.required],
      validity: [365, [Validators.required, Validators.min(1)]],
      features: [],
      featureName: [''],
    });
  }

  featureListOptions: any[] = [
    { name: 'leads', value: 'leads' },
    { name: 'applications', value: 'applications' },
    { name: 'registration', value: 'registration' },
    { name: 'settings', value: 'settings' }
  ];

  ngOnInit() {
    if (this.type === 'Update') {
      this.packageForm.patchValue({
        package_name: this.selectedPackage.package_name,
        type: this.selectedPackage.type,
        is_customized: this.selectedPackage.is_customized,
        status: this.selectedPackage.status,
        validity: this.selectedPackage.validity,
        features: this.selectedPackage.features.map((feature: any) => ({ name: feature, value: feature })),
      });
    }
  }



  addFeature() {
    let name = this.packageForm.get('featureName')?.value;

    if (name) {
      this.featureListOptions.push({ name, value: name });
      this.packageForm.get('featureName')?.setValue('');
      this.cdr.detectChanges();
    }
  }


  submitForm() {
    this.isLoading = true;
    if (this.packageForm.valid) {

      const payload: any = {
        package_name: this.packageForm.get('package_name')?.value,
        features: this.packageForm.get('features')?.value?.map((feature: any) => feature.value),
        type: this.packageForm.get('type')?.value,
        is_customized: this.packageForm.get('is_customized')?.value,
        status: this.packageForm.get('status')?.value,
        validity: this.packageForm.get('validity')?.value
      };


      if (this.type === 'Create') {
        this.packageService.createPackage(payload).subscribe((res) => {
          if (res) {
            this.isLoading = false;
            this.reload.emit();
            this.close.emit();
          }
        }, (error) => {
          console.error('Error creating package:', error);
          this.isLoading = false;
        });

      } else if (this.type === 'Update') {
        payload.package_id = this.selectedPackage.package_id;
        this.packageService.updatePackage(payload).subscribe((res) => {
          if (res) {
            this.isLoading = false;
            this.reload.emit();
            this.close.emit();
          }
        }, (error) => {
          console.error('Error updating package:', error);
          this.isLoading = false;
        });
      }

    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

}
